import { render, staticRenderFns } from "./StomachCancer.vue?vue&type=template&id=10c0958e&scoped=true"
import script from "./StomachCancer.vue?vue&type=script&lang=js"
export * from "./StomachCancer.vue?vue&type=script&lang=js"
import style0 from "./StomachCancer.vue?vue&type=style&index=0&id=10c0958e&prod&lang=scss&scoped=true"
import style1 from "./StomachCancer.vue?vue&type=style&index=1&id=10c0958e&prod&lang=scss&scoped=true"
import style2 from "./StomachCancer.vue?vue&type=style&index=2&id=10c0958e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c0958e",
  null
  
)

export default component.exports